import _ from 'lodash'
import DatasetsDateTimeFilterPicker from './datasets-date-time-filter-picker'
import DatasetsDateFilterStep2 from './datasets-date-filter-step2'
import momentHelper from 'scoreboard/components/moment-helper'
import i18n from 'scoreboard/components/i18n'
import $ from 'jquery'
import DataType from 'scoreboard/datasets/model/data-type'
const { TIME } = DataType

/**
 * The second view in the datasets date/time filter wizard. This is specific to
 * fields which are of type time, date, or date+time
 */
var DatasetsDateTimeFilterStep2 = DatasetsDateFilterStep2.extend({

	className: DatasetsDateFilterStep2.prototype.className + ' datasets-date-time-filter-step2',

	render: function() {
		DatasetsDateFilterStep2.prototype.render.apply(this, arguments)
		this.renderZoneAdjustmentBanner()
	},

	renderZoneAdjustmentBanner: function() {
		const [fieldZone, browserZone] = this._getFieldAndBrowserTimezones()
		const text = i18n.get('datasets.filters.time.adjustmentExplanation',
			browserZone, fieldZone)

		$('<div></div>', {
			text, class: 'banner banner-description is-not-displayed'
		}).prependTo(this.$('.dialog-body-content'))
	},

	_getFieldAndBrowserTimezones: function() {
		const filter = this.options.filter
		const field = this.options.model.combinedFieldsById[filter.fieldId]
		const browserZone = momentHelper.defaultTimeZone()
		const fieldZone = _.result(field, 'timeZone') || browserZone
		return [fieldZone, browserZone]
	},

	renderPicker() {
		this.picker = new DatasetsDateTimeFilterPicker(_.extend({
			formView: this.formView
		}, this.options))

		this.$('.dialog-body-content').append(this.picker.el)
		this.picker.render()
	},

	_setupListeners() {
		this.listenTo(this.picker, 'change', this.formView.change.bind(this.formView))
		this.listenTo(this.picker, 'toggleChooseBy', chooseBy =>
			this.toggleChooseBy(chooseBy))
	},

	toggleChooseBy: function(chooseBy) {
		const [fieldZone, browserZone] = this._getFieldAndBrowserTimezones()
		const zonesDiffer = fieldZone && fieldZone !== browserZone
		const displayBanner = zonesDiffer && chooseBy === TIME
		this.$('.banner-description').toggleClass('is-not-displayed', !displayBanner)
	},

	saveState: function() {
		if (this.options.wizard) {
			this.options.wizard.options.filter = this.picker.val()
		}
		return this.picker.val()
	}
})

export default DatasetsDateTimeFilterStep2

DatasetsDateTimeFilterStep2.__filename__ = 'datasets/filters/datasets-date-time-filter-step2.js'
